import React, { Fragment, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Select from "react-select";
import "../Inventory.css";
import { getItemList } from "../../../Helpers/apiCalls/Inventory/ItemListApi";
import {
  numberFormat,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common";
import { createAdjustment } from "../../../Helpers/apiCalls/Inventory/AdjustmentApi";
import { searchEmployee } from "../../../Helpers/apiCalls/employeesApi";
import toast from "react-hot-toast";
import { getAllAdjustmentTypes } from "../../../Helpers/apiCalls/adjustmentsApi";
import ReactLoading from "react-loading";
import InputError from "../../../Components/InputError/InputError";
import { validateAdjustment } from "../../../Helpers/Validation/Inventory/AdjustmentValidation";
import trash from "../../../Assets/Images/trash.png";
import Modal from "antd/es/modal/Modal";
import Upload from "antd/es/upload/Upload";
import upload from "../../../Assets/Images/upload.png";
import FileExceedModal from "../../../Components/Modals/FileExceedModal";
import Compressor from "compressorjs";
import Footer from "../../../Components/Footer/Footer";

/**
 *  COMPONENT: FORM TO ADD OR EDIT PAYMENT
 */
function BranchAdjustment() {
  const {Dragger} = Upload;
  const [inactive, setInactive] = useState(true);
  const { id, type } = useParams();
  let navigate = useNavigate();
  const [preview, setPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState('');
  const [prevAttachments, setPrevAttachments] = useState([]);
  const [showFileExceedModal, setShowFileExceedModal] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [newItemAdjust, setNewItemAdjust] = useState({
    difference: "",
  });
  const [filterConfig, setFilterConfig] = useState({
    department: "",
    employee_type: "",
    status: "active",
  });
  const [isClicked, setIsClicked] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [adjustments, setAdjustments] = useState([]);
  const [isError, setIsError] = useState({
    counted_by: false,
    type_id: false,
    physical_count: false,
    difference: false,
  });

  async function fetchAdjustmentTypes() {
    const response = await getAllAdjustmentTypes();

    if (response.data) {
      var adjustmentTypes = response.data.data.map((type) => {
        var info = {};
        info.value = type.id;
        info.name = "type_id";
        info.label = type.name;
        return info;
      });
      setAdjustments(adjustmentTypes);
    } else {
      TokenExpiry(response);
    }
  }

  const [employeeOptions, setEmployeeOptions] = useState([]);

  async function fetchData(id) {
    setItemList([]);

    const response = await getItemList(id);

    if (response.error) {
    } else {
      var data = response.data.data[0];
      setItemList({
        id: data.id,
        branch_id: data.branch_id,
        branch_name: data.branch_name,
        item_name: data.item_name,
        item_type: data.item_type,
        current_qty: data.current_qty,
        unit: data.unit,
        min: data.min,
        max: data.max,
        acceptable_variance: data.acceptable_variance,
        unit_to_name: data.unit_to_name,
      });
      setNewItemAdjust({
        inventory_id: data.id,
        item_id: data.item_id,
        branch_id: data.branch_id,
        branch_name: data.branch_name,
        unit: data.unit,
      });
    }
  }

  //API CALL
  async function fetchAllEmployees() {
    setEmployeeOptions([]);
    const response = await searchEmployee(filterConfig);

    if (response.data.data) {
      var employeesList = response.data.data.map((employee) => {
        var info = {};

        info.name = "counted_by";
        info.label = `${employee.first_name} ${
          employee.middle_name ? employee.middle_name : ""
        } ${employee.last_name}`;
        info.value = employee.id;
        return info;
      });
      setEmployeeOptions(employeesList);
    }
  }

  async function saveAdjustment() {
    if (validateAdjustment(newItemAdjust, setIsError)) {
      setIsClicked(true);
      newItemAdjust.attachments = fileList
      const response = await createAdjustment(newItemAdjust);
      if (response.data) {
        toast.success(response.data.message, { style: toastStyle() });
        setTimeout(() => {
          navigate("/itemlists");
        }, 1000);
      } else {
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
      }
      setIsClicked(false);
    } else {
      toast.error("Please fill in all fields.", {
        style: toastStyle(),
      });
    }
  }

  const [employeeValue, setEmployeeValue] = useState({
    name: "counted_by",
    label: "",
    value: "",
  });

  function handleUserInput(e) {
    const { name, value } = e.target;
    const newList = newItemAdjust;
    newList[name] = value;
    setNewItemAdjust(newList);

    if (name === "physical_count") {
        var count = value !== "" ? value : 0
        var difference = value !== "" ? (parseFloat(count) - parseFloat(itemList.current_qty)).toFixed(2) : "";
        newList["difference"] = difference
        setNewItemAdjust(newList);
        setNewItemAdjust({
            ...newItemAdjust,
            is_difference_disabled: value !== "" ? true : false,
            is_physical_count_disabled: false,
            difference: difference
        });
    } else if (name === "difference") {
        var count = value !== "" ? value : 0
        var physical_count = value !== "" ? (parseFloat(count) + parseFloat(itemList.current_qty)).toFixed(2) : "";
        newList["physical_count"] = physical_count
        setNewItemAdjust(newList);
        setNewItemAdjust({
            ...newItemAdjust,
            is_difference_disabled: false,
            is_physical_count_disabled: value !== "" ? true : false,
            physical_count: physical_count
        });
    }
  }

  // SELECT DROPSEARCH CHANGE HANDLER
  function handleSelectChange(e) {
    const newList = newItemAdjust;
    newList[e.name] = e.value;
    setNewItemAdjust(newList);

    if (e.name === "counted_by")
      setEmployeeValue({ name: e.name, label: e.label, value: e.value });
  }

  useEffect(() => {
    fetchData(id);
    fetchAllEmployees();
    fetchAdjustmentTypes();
  }, []);

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
      var numericInputs = document.querySelectorAll('.numeric-input');
      numericInputs.forEach(function(input) {
        input.addEventListener('wheel', function(e) {
          e.preventDefault();
        });
      });
    }
    limitScroll();


    const handleRemove = (selectedFile) => {
        var newlist = fileList.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFileList(newlist);
    };

    const handleBeforeUpload = (file) => {
        if (file.size > 2000000) {
            setShowFileExceedModal(true);
        } else {
            //COMPRESSING FILE
            new Compressor(file, {
                quality: 0.6,
                success: (compressedResult) => {
                    setFileList([...fileList, compressedResult]);
                },
            });
        }
        return false;
    };

    function handleRemoveItemAttachment(url) {
        
        var newList = prevAttachments.filter((data) => {return data.file_url !== url})
        setPrevAttachments(newList);
        setPreview(false)
    }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"INVENTORY"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={8}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ADJUST INVENTORY</h1>
          </Col>
        </Row>

        {/* FORM */}

        <div className="edit-form ps-form">
          <Fragment>
            <Row className="review-container py-3 mb-3">
              <Row>
                <Col xs={6} lg={3}>
                  <span className="review-label nc-modal-custom-row">
                    Item Description
                  </span>
                </Col>
                <Col xs={6} lg={3} className="mt-4 mt-lg-0">
                  <span className="review-data">{itemList.item_name}</span>
                </Col>

                <Col xs={6} lg={3} className="mt-4 mt-lg-0">
                  <span className="review-label nc-modal-custom-row">
                    Inventory Unit
                  </span>
                </Col>
                <Col xs={6} lg={3} className="mt-4 mt-lg-0">
                  <span className="review-data">
                    {itemList.unit}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col xs={6} lg={3}>
                  <span className="review-label nc-modal-custom-row">
                    Branch
                  </span>
                </Col>
                <Col xs={6} lg={3} className="mt-4 mt-lg-0">
                  <span className="review-data">{itemList.branch_name}</span>
                </Col>
                <Col xs={6} lg={3} className="mt-4 mt-lg-0">
                  <span className="review-label nc-modal-custom-row">
                    Current Level
                  </span>
                </Col>
                <Col xs={6} lg={3} className="mt-4 mt-lg-0">
                  <span className="review-data">
                    {numberFormat(itemList.current_qty)}
                  </span>
                </Col>
              </Row>
            </Row>
            <Row className="mb-3">
              <Col xs={12} lg={6}>
                <span className="nc-modal-custom-row uppercase">
                  counted by
                  <label className="badge-required">{` *`}</label>
                </span>
                <Select
                  name="counted_by"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Employee..."
                  defaultValue={employeeValue}
                  options={employeeOptions}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.counted_by}
                  message={"Counted by is required"}
                />
              </Col>
              <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  adjustment type
                  <label className="badge-required">{` *`}</label>
                </span>
                <Select
                  name="type_id"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Adjustment Type..."
                  defaultValue={newItemAdjust.type_id}
                  options={adjustments}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.type_id}
                  message={"Type id is required"}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} lg={6}>
                <span className="nc-modal-custom-row uppercase">
                  Physical count
                  <label className="badge-required">{` *`}</label>
                </span>
                <Form.Control
                    type="number"
                    name="physical_count"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={newItemAdjust.physical_count}
                    onChange={(e) => handleUserInput(e)}
                    disabled={newItemAdjust.is_physical_count_disabled}
                />
                <InputError
                  isValid={isError.physical_count}
                  message={"Physical count is required"}
                />
              </Col>
              <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  difference
                  <label className="badge-required">{` *`}</label>
                </span>
                <Form.Control
                    type="number"
                    name="difference"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={newItemAdjust.difference}
                    onChange={(e) => handleUserInput(e)}
                    disabled={newItemAdjust.is_difference_disabled}
                />
                <InputError
                  isValid={isError.difference}
                  message={"Difference is required"}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} lg={4}>
                <span className="nc-modal-custom-row uppercase">
                   QTY on Receipt
                  {/* <label className="badge-required">{` *`}</label> */}
                </span>
                <Form.Control
                    type="number"
                    name="qty_on_receipt"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={newItemAdjust.qty_on_receipt}
                    onChange={(e) => handleUserInput(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  Date Delivered
                </span>
                <Form.Control
                    type="date"
                    name="date_delivered"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={newItemAdjust.date_delivered}
                    onChange={(e) => handleUserInput(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="nc-modal-custom-row uppercase">
                  Date Counted
                </span>
                <Form.Control
                    type="date"
                    name="date_counted"
                    className="nc-modal-custom-text hide-spinner numeric-input"
                    value={newItemAdjust.date_counted}
                    onChange={(e) => handleUserInput(e)}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <span className="nc-modal-custom-row uppercase">
                  remarks
                  <span className="edit-optional px-2">(Optional)</span>
                </span>
                <Form.Control
                  as="textarea"
                  name="remarks"
                  defaultValue={newItemAdjust.remarks}
                  className="nc-modal-custom-row-grey"
                  onChange={(e) => handleUserInput(e)}
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col>
                  <Dragger
                      fileList={fileList}
                      onRemove={handleRemove}
                      beforeUpload={handleBeforeUpload}
                      multiple={false}
                      listType="picture"
                      progress={{ showInfo: true }}
                  >
                      <img src={upload} className="cursor-pointer" />
                      <p className="ant-upload-text">
                          Click or drag file to this area to upload
                      </p>
                  </Dragger>
              </Col>
            </Row>
          </Fragment>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Close
            </button>
            {isClicked === true && (
              <div className="button-primary d-flex justify-content-center me-3">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            )}
            {isClicked === false && (
              <button
                type="button"
                className="button-primary me-3"
                onClick={() => saveAdjustment()}
              >
                Request
              </button>
            )}
          </div>
        </div>
      </div>
      <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
          <Row className="justify-content-center">
              <img
                  alt="example"
                  style={{
                  width: '100%',
                  }}
                  src={previewFile}
              />
              <div className="mt-2 d-flex justify-content-center">
                  <img
                      src={trash}
                      alt="trash"
                      onClick={() => handleRemoveItemAttachment(previewFile)}
                      className="cursor-pointer"
                  />
              </div>
          </Row>
      </Modal>
      <FileExceedModal
          show={showFileExceedModal}
          onHide={() => setShowFileExceedModal(false)}
          size="2MB"
      />
      <Footer/>
    </div>
  );
}

export default BranchAdjustment;
